import { instanceAxios } from "../../../utils";
import { URL_BACK } from "../../backend.enpoints";
import { headerAuth } from "../../request";
import { formatErrorField } from "../../../utility/formatText";
import OneSignal from "react-onesignal";

export const changeRole = (role) => {
  return (dispatch) => dispatch({ type: "CHANGE_ROLE", userRole: role });
};

export function login(data) {
  return async (dispatch, getState) => {
    // Agregar force_close_others por defecto
    const loginData = {
      ...data,
      force_close_others: true
    };

    await instanceAxios
      .post(`${URL_BACK.AUTH}/login`, loginData)
      .then(async (response) => {
        const data = response.data.data;

        if (response.hasOwnProperty("name")) {
          if (response.data.status === 404 || response.data.status === 403) {
            dispatch({
              type: "SHOW",
              message:
                response.data.response ||
                "Tu contraseña no está registrada en la plataforma, inténtalo otra vez.",
              button: "Entendido",
            });
          }
          return;
        }

        localStorage.setItem("token", "Bearer " + data.token);

        instanceAxios.defaults.headers.common = {
          Authorization: "Bearer " + data.token,
        };

        let rolActive =
          data.roles.length > 0
            ? data.roles.find((rol) => rol.status == true)?.name
            : "member";
        if (rolActive == undefined) {
          rolActive = 'member';
        }

        dispatch({
          type: "LOGIN",
          payload: {
            userRole: rolActive,
            userName: data.name,
            permissions: data.permissions,
            token: data.token,
            headquarter: data.headquarter,
            box: data.box ? data.box : "",
            usedBox: data.useBox ? data.useBox : false,
            member: data.member ? data.member : {},
            firstLogin: data.first_login,
            roles: data.roles,
          },
        });

        dispatch({
          type: "DATA_PROFILE",
          payload: data.member ? data.member : {},
        });

        if (data.member) {
          await OneSignal.setExternalUserId(`${data.member.id}`);
        }

        return true;
      })
      .catch((error) => {
        if (error.response) {
          const { data, status } = error.response;
          if (status === 401) {
            dispatch({
              type: "SHOW",
              message:
                data.message ||
                "Tu contraseña no está registrada en la plataforma, inténtalo otra vez.",
              button: "Entendido",
            });
          }
        }
        return formatErrorField(error);
      });
  };
}

export function profileAction(id) {
  return async (dispatch, getState) => {
    try {
      const response = await instanceAxios.get(
        `${URL_BACK.MEMBERS}/${id}`,
        headerAuth()
      );
      dispatch({
        type: "DATA_PROFILE",
        payload: response.data.data,
      });
      return response.data;
    } catch (error) {
      return formatErrorField(error);
    }
  };
}

export function updateProfileAction(data) {
  return async (dispatch, getState) => {
    try {
      await instanceAxios.post(
        `${URL_BACK.GENERAL}/updateProfile`,
        data,
        headerAuth()
      );
      dispatch(profileAction());
      dispatch({
        type: "SHOW",
        message: "Datos actualizados exitosamente",
        button: "Entendido",
      });
      return true;
    } catch (error) {
      return formatErrorField(error);
    }
  };
}

export function forgotPasswordAction(data) {
  return async (dispatch, getState) => {
    try {
      const response = await instanceAxios.post(
        `${URL_BACK.AUTH}/forgetPassword`,
        data,
        headerAuth()
      );
      dispatch({
        type: "SHOW",
        message: "Hemos enviado las instrucciones a tu correo electrónico",
        button: "Entendido",
      });
      return response.data;
    } catch (error) {
      return formatErrorField(error);
    }
  };
}

export function restaurePasswordAction(data) {
  return async (dispatch, getState) => {
    try {
      await instanceAxios.post(
        `${URL_BACK.AUTH}/resetPassword`,
        data,
        headerAuth()
      );
      dispatch({
        type: "SHOW",
        message:
          "Cambios guardados exitosamente, ahora puede iniciar su sesión",
        button: "Entendido",
        init: true,
      });
      return true;
    } catch (error) {
      return formatErrorField(error);
    }
  };
}

export function changePasswordAction(data) {
  return async (dispatch, getState) => {
    try {
      await instanceAxios.post(
        `${URL_BACK.GENERAL}/passwordChange`,
        data,
        headerAuth()
      );
      dispatch({
        type: "SHOW",
        message: "Cambios guardados exitosamente",
        button: "Entendido",
      });
      return true;
    } catch (error) {
      return formatErrorField(error);
    }
  };
}

export function updateMailAction(data) {
  return async (dispatch, getState) => {
    try {
      const response = await instanceAxios.put(
        `${URL_BACK.AUTH}/updateProfile`,
        data,
        headerAuth()
      );
      dispatch({
        type: "SHOW",
        message: "Correo cambiado exitosamente",
        button: "Entendido",
      });
      return response.data;
    } catch (error) {
      return formatErrorField(error);
    }
  };
}

export function updatePasswordAction(data) {
  return async (dispatch, getState) => {
    try {
      await instanceAxios.put(
        `${URL_BACK.AUTH}/updatePassword`,
        data,
        headerAuth()
      );
      dispatch({
        type: "SHOW",
        message: "Contraseña cambiada exitosamente",
        button: "Entendido",
      });
      return true;
    } catch (error) {
      return formatErrorField(error);
    }
  };
}

export function updateMainRoldAction(data) {
  return async (dispatch, getState) => {
    try {
      await instanceAxios.put(
        `${URL_BACK.AUTH}/updateMainRole`,
        data,
        headerAuth()
      );
      return true;
    } catch (error) {
      return formatErrorField(error);
    }
  };
}

export function sendEmailToRecoverPasswordAction(data) {
  return async (dispatch, getState) => {
    try {
      const response = await instanceAxios.post(
        `${URL_BACK.AUTH}/forgetPassword`,
        data,
        headerAuth()
      );
      return response.data.data;
    } catch (error) {
      return formatErrorField(error);
    }
  };
}

export function verifyCodeAction(data) {
  return async (dispatch, getState) => {
    try {
      const response = await instanceAxios.post(
        `${URL_BACK.AUTH}/verifyCode`,
        data,
        headerAuth()
      );
      return response.data;
    } catch (error) {
      return formatErrorField(error);
    }
  };
}

export function resetPasswordAction(data) {
  return async (dispatch, getState) => {
    try {
      const response = await instanceAxios.post(
        `${URL_BACK.AUTH}/resetPassword`,
        data,
        headerAuth()
      );
      dispatch({
        type: "SHOW",
        message: "Contraseña cambiada exitosamente",
        button: "Entendido",
      });
      dispatch({
        type: "UPDATE_FIRST_LOGIN",
      });
      return response.data.success;
    } catch (error) {
      return formatErrorField(error);
    }
  };
}

export function refreshUserDataAction() {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const memberId = state.auth.memberId;
      const token = localStorage.getItem("token");

      if (!memberId || !token) {
        console.log("No member ID or token found, skipping refresh");
        return false;
      }

      console.log("refreshUserDataAction")

      // Obtener datos actualizados del usuario
      const response = await instanceAxios.get(
        `${URL_BACK.MEMBERS}/${memberId}`,
        headerAuth()
      );

      const userData = response.data.data;

      console.log("userData.roles", userData.roles)
      console.log("userData.main_role", userData.main_role)

      // Determinar el rol principal
      let rolActive = userData.main_role ? userData.main_role : "member";

      if (!rolActive) {
        rolActive = 'member';
      }

      // Transformar los roles del backend al formato que espera la aplicación
      let rolesFormatted = [];

      if (userData.roles && Array.isArray(userData.roles)) {
        // Verificar si los roles ya vienen con formato {name, status} o solo como strings
        if (userData.roles.length > 0 && typeof userData.roles[0] === 'object' && userData.roles[0].hasOwnProperty('status')) {
          // Los roles ya vienen con el formato correcto {name, status}
          rolesFormatted = userData.roles;
        } else {
          // Los roles vienen como array de strings, necesitamos transformarlos
          rolesFormatted = userData.roles.map(roleName => ({
            name: roleName,
            status: roleName === rolActive // true si es el rol principal, false si no
          }));
        }
      } else {
        // Fallback: crear array con solo el rol principal
        rolesFormatted = [{
          name: rolActive,
          status: true
        }];
      }

      console.log("rolesFormatted", rolesFormatted);

      // Actualizar Redux con los datos frescos
      dispatch({
        type: "UPDATE_ROLES",
        payload: {
          roles: rolesFormatted,
          mainRole: rolActive,
        },
      });

      dispatch({
        type: "DATA_PROFILE",
        payload: userData,
      });

      console.log("User data refreshed successfully");
      return true;
    } catch (error) {
      console.error("Error refreshing user data:", error);
      // Si hay error de autenticación, limpiar datos
      if (error.response && error.response.status === 401) {
        dispatch(logoutAction());
      }
      return false;
    }
  };
}

// Nueva acción para inicializar la aplicación
export function initializeAppAction() {
  return async (dispatch, getState) => {
    try {
      const token = localStorage.getItem("token");
      const state = getState();
      const memberId = state.auth.memberId;

      if (token && memberId) {
        // Configurar el token en axios
        instanceAxios.defaults.headers.common = {
          Authorization: token,
        };

        // Refrescar datos del usuario
        await dispatch(refreshUserDataAction());

        console.log("App initialized successfully");
        return true;
      } else {
        console.log("No token or member ID found, user not logged in");
        return false;
      }
    } catch (error) {
      console.error("Error initializing app:", error);
      return false;
    }
  };
}

export function updateMainRoleAction(data, isRedirect = true) {
  return async (dispatch, getState) => {
    try {
      const response = await instanceAxios.put(
        `${URL_BACK.AUTH}/updateMainRole`,
        data,
        headerAuth()
      );
      dispatch({ type: "PAYMENT_DEFAULT_TAB" });
      dispatch({ type: "SALONES_DEFAULT_TAB" });
      dispatch({ type: "MA_DEFAULT_TAB" });
      if (isRedirect) {
        dispatch({
          type: "SHOW",
          message: "Se actualizó el rol principal exitosamente",
          button: "Entendido",
        });
      }
      return response.data;
    } catch (error) {
      return formatErrorField(error);
    }
  };
}

export function logoutAction() {
  return async (dispatch, getState) => {
    try {
      // Llamar al endpoint de logout
      await instanceAxios.post(`${URL_BACK.AUTH}/logout`, {}, headerAuth());

      // Limpiar datos locales después de la respuesta exitosa
      dispatch({ type: "RESOURCE_UPLOAD", payload: true });
      dispatch({ type: "LOGOUT", payload: {} });
      localStorage.clear();
      localStorage.removeItem("token");

      return true;
    } catch (error) {
      // Aunque falle la llamada al servidor, limpiar datos locales
      dispatch({ type: "RESOURCE_UPLOAD", payload: true });
      dispatch({ type: "LOGOUT", payload: {} });
      localStorage.clear();
      localStorage.removeItem("token");

      return formatErrorField(error);
    }
  };
}

export default {
  changeRole,
  login,
  profileAction,
  updateProfileAction,
  forgotPasswordAction,
  restaurePasswordAction,
  changePasswordAction,
  updateMailAction,
  updatePasswordAction,
  updateMainRoldAction,
  sendEmailToRecoverPasswordAction,
  verifyCodeAction,
  resetPasswordAction,
  updateMainRoleAction,
  // refreshUserDataAction,
  initializeAppAction,
  logoutAction,
};
